import moment from 'moment';

/**
 * Returns list of events transformed to fullcalendar.js event objects.
 * @param {Array.<object>} events
 * @return {Array.<object>}
 */
export default function eventsToCalendar(events) {
  return events.map(event => (
    {
      id: event.EVENT_ID,
      title: event.EVENT_NAME,
      allDay: true,
      start: event.START_DATE,
      end: moment(event.END_DATE).add(1, 'day')
    })
  );
}



// WEBPACK FOOTER //
// ./src/services/eventsToCalendar.js